// See documentation on thunk here: https://github.com/reduxjs/redux-thunk
import thunk from 'redux-thunk';
export default thunk;